import { createStore, applyMiddleware } from 'redux';
import createSagaMiddleware, { END } from 'redux-saga';
import rootReducer from './reducers';
import { composeWithDevTools } from 'redux-devtools-extension';
import { loadingBarMiddleware } from 'react-redux-loading-bar';

export default function configureStore(initialState) {
    const sagaMiddleware = createSagaMiddleware();

    const store = createStore(

        rootReducer,
        initialState,
        composeWithDevTools(
            applyMiddleware(
                sagaMiddleware,
                loadingBarMiddleware({
                    promiseTypeSuffixes: ['REQUEST', 'SUCCESS', 'ERROR'],
                })
            ),
        )
    );

    if (process.env.NODE_ENV === 'development') {
        if (module.hot) {
            // Enable Webpack hot module replacement for reducers
            module.hot.accept('./reducers', () => {
                const nextRootReducer = require('./reducers').default;
                store.replaceReducer(nextRootReducer)
            })
        }
    }
    store.runSaga = sagaMiddleware.run;
    store.close = () => store.dispatch(END);
    return store
}


// WEBPACK FOOTER //
// ./src/redux/store.js